import {
  ClientEmployeeFragment,
  useClientEmployeeQuery,
  useDeleteClientEmployeeMutation,
} from "@graphql/client-employees/clientEmployees.g";

import { UpdateClientEmployeeForm } from "@components/Forms";

import { Box } from "@design-system/Box/Box";
import { Button } from "@design-system/Button/Button";
import { Card } from "@design-system/Card/Card";
import { Text } from "@design-system/Text/Text";

type Props = {
  clientId: string;
  clientEmployeeId: string;
  onUpdateClientEmployeeSuccess?: (
    data: ClientEmployeeFragment,
  ) => Promise<void> | void;
  onDeleteSuccess?: () => void;
};

export const UpdateClientEmployeeCard = ({
  clientId,
  clientEmployeeId,
  onUpdateClientEmployeeSuccess,
  onDeleteSuccess,
}: Props) => {
  const clientEmployeeQuery = useClientEmployeeQuery({
    clientId,
    clientEmployeeId,
  });
  const deleteClientEmployeeMutation = useDeleteClientEmployeeMutation();
  const deleteClientEmployee = deleteClientEmployeeMutation.mutateAsync;

  const clientEmployee = clientEmployeeQuery.data?.clientEmployee;
  const isArchived = Boolean(clientEmployee?.archivedAt);

  const handleDeleteClick = async () => {
    await deleteClientEmployee({
      input: { clientId, id: clientEmployeeId },
    });
    onDeleteSuccess?.();
  };

  return (
    <Card>
      <Card.Header>
        <Card.Header.Title>
          {isArchived ? "Archived user" : "Update user"}
        </Card.Header.Title>
      </Card.Header>
      <Card.Body>
        {isArchived && clientEmployee && (
          <Box padding="0 0 24px 0">
            <Text size={14} color="textSecondary">
              Archived on{" "}
              {new Date(clientEmployee.archivedAt!).toLocaleDateString()}
              {clientEmployee.archivedBy
                ? ` by ${
                    clientEmployee.archivedBy.name ||
                    clientEmployee.archivedBy.email
                  }`
                : ""}
              . Historical usage data remains available on the Dashboard and File
              Uploads tabs.
            </Text>
          </Box>
        )}
        {!isArchived && (
          <>
            <UpdateClientEmployeeForm
              clientId={clientId}
              clientEmployeeId={clientEmployeeId}
              onUpdateClientEmployeeSuccess={onUpdateClientEmployeeSuccess}
            />
            <div style={{ marginTop: 24 }}>
              <Button
                variant="outlined"
                color="danger"
                icon="faTrash"
                onClick={handleDeleteClick}
              >
                Delete employee
              </Button>
            </div>
          </>
        )}
      </Card.Body>
    </Card>
  );
};
